const FEATURE_FLAGS = {
  NEW_DASHBOARD: 'sales-exp-dashboard-v3',
  SPLAT_ROLE_ENABLED: 'sales-exp-dashboard-v3-splat-role-enabled',
  SALES_CHAT_ENABLED: 'sales-chat-enabled',
  NEW_LIST_VIEW_ON_PIPELINE: 'sales-exp-new-list-view-on-pipeline',
  SFDC_URL: 'sfdc-url',
  SFDC_PARTNER_URL: 'sfdc-partner-url',
  PAYMENT_OUTAGE: 'sales-exp-payment-outage',
  NEW_LEADERBOARD_ENABLED: 'new-leaderboard-enabled',
  RUN_X_TRAININGS: 'sales-exp-run-x-trainings',
  RUN_X_TRAININGS_MAJSTG_MOCKED_DATA:
    'sales-exp-run-x-trainings-majstg-mocked-data',
  COACHING_ENABLED: 'sales-exp-coaching-enabled',
  HELIOS_V0: 'helios_v0',
  DIRECTOR_PIPELINE_HIERARCHY: 'sales-exp-director-pipeline-hierarchy',
  THE_BIGS_LINK: 'sales-exp-the-bigs-link',
  WORKDAY_HOURS_WORKFLOW: 'sales-exp-clock-in-clock-out-workday-hours-workflow',
  ACADEMY_PAGE: 'sales-exp-academy-page',
  NEW_PRESENTATION: 'sales-exp-new-presentation',
  PIPELINE_V2_STYLING: 'sales-exp-pipeline-v2-styling',
  PIPELINE_V2_LAYOUT: 'sales-exp-pipeline-v2-new-layout',
  PIPELINE_V2_OPPTY_STAGE_COLUMNS: 'sales-exp-pipeline-v2-oppty-stages-columns',
};

export { FEATURE_FLAGS };
